import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Input,
  FormGroup,
  Label,
  Table,
} from "reactstrap";
import ResponseLoader from "../../ShortCutComponents/ResponseLoader";
import swal from "sweetalert2";
import axios from "axios";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import { baseurl } from "../../../../baseurl";

export default function TransType(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");

  const [loadingResponse, setLoadingResponse] = useState(false);
  const [data, setData] = useState({
    desc1: "",
    showModalAddNew: true,
  });
  const [TransType, setTransType] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({ desc1: "" });

  const cleanInput = () => {
    setData({ desc1: "" });
  };

  const getData = () => {
    axios
      .post(
        `${baseurl}/payRoll/getTransType`,
        { companyId, username },
        { headers: { authorization: token } }
      )
      .then((res) => {
        setTransType(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getData();
  }, []);

  const inputEvent = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmitAddItem = async (event) => {
    event.preventDefault();
    setLoadingResponse(true);
    let { userIp, userCountry } = await GetIp();

    axios
      .post(
        `${baseurl}/payRoll/AddTransType`,
        {
          companyId,
          desc1: data.desc1,
          username,
          userIp,
          userCountry,
        },
        { headers: { authorization: token } }
      )
      .then((response) => {
        setLoadingResponse(false);
        if (response.data.duplicate) {
          swal.fire({
            title: "Duplicate Code is not Allowed",
            text: "Duplicate Entry",
            icon: "error",
          });
        } else {
          swal
            .fire({
              title: "Saved Successfully!",
              text: "TransType Added",
              icon: "success",
            })
            .then(() => {
              console.log("response.data.data", response.data.data);
              setTransType([
                ...TransType,
                { trans_type_id: response.data.data, desc1: data.desc1 },
              ]);
              setData({ desc1: "" });
            });
        }
      })
      .catch(() => {
        setLoadingResponse(false);
        swal.fire({
          title: "Error",
          text: "Something went wrong. Try again.",
          icon: "error",
        });
      });
  };

  const handleEdit = (TransType) => {
    console.log("TransType", TransType);
    setEditingId(TransType.trans_type_id);
    setEditData({ desc1: TransType.desc1 });
  };

  const handleUpdate = () => {
    axios
      .post(
        `${baseurl}/payRoll/updateTransType`,
        {
          companyId,
          username,
          Id: editingId,
          desc1: editData.desc1,
        },
        { headers: { authorization: token } }
      )
      .then(() => {
        setTransType(
          TransType.map((item) =>
            item.id === editingId ? { ...item, ...editData } : item
          )
        );
        console.log("editingId", editingId);
        setEditingId(null);
        getData();

        swal.fire({
          title: "Updated!",
          text: "TransType Updated Successfully",
          icon: "success",
        });
      })
      .catch(() => {
        swal.fire({
          title: "Error",
          text: "Something went wrong, try again.",
          icon: "error",
        });
      });
  };
  const handleDelete = (trans_type_id) => {
    swal
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        buttons: ["Cancel", "Delete"],
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          axios
            .post(
              `${baseurl}/payRoll/deleteTransType`,
              { companyId, username, Id: trans_type_id },
              { headers: { authorization: token } }
            )
            .then(() => {
              setTransType(
                TransType.filter((item) => item.trans_type_id !== trans_type_id)
              );
              swal.fire("Deleted!", "TransType has been deleted.", "success");
            })
            .catch(() => {
              swal.fire("Error!", "Something went wrong. Try again.", "error");
            });
        }
      });
  };

  return (
    <>
      {loadingResponse ? (
        <ResponseLoader />
      ) : (
        <div className="container-fluid bg-white pb-2">
          <div className="row d-flex justify-content-between">
            <div className="col-md-8 h3 p-3">Trans Type</div>
            <div className="mt-3 mr-4"></div>
          </div>
          <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Label style={{ fontWeight: "bold" }}>
                  Trans Type Description:
                </Label>
                <Input
                  value={data.desc1}
                  onChange={inputEvent}
                  required
                  name="desc1"
                />
              </div>
            </div>
            <FormGroup>
              <Button type="submit" className="mr-2 invoiceSubmitButton">
                Save
              </Button>
              <Button onClick={cleanInput} size="sm">
                Cancel
              </Button>
            </FormGroup>
          </Form>

          <div translate="no" className="mb-2">
            <Table bordered striped className="mt-4 ">
              <thead>
                <tr>
                  <th>Trans Type Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {TransType.length > 0 ? (
                  TransType.map((TransType) => (
                    <tr key={TransType.trans_type_id}>
                      <td>
                        {editingId === TransType.trans_type_id ? (
                          <Input
                            value={editData.desc1}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                desc1: e.target.value,
                              })
                            }
                          />
                        ) : (
                          TransType.desc1
                        )}
                      </td>
                      <td width="20%">
                        {editingId === TransType.trans_type_id ? (
                          <>
                            <Button
                              type="button"
                              className="m-1"
                              size="sm"
                              color="secondary"
                              onClick={() => {
                                setEditingId(null); // Cancel editing
                                setEditData({
                                  desc1: "",
                                });
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="success"
                              size="sm"
                              onClick={handleUpdate}
                            >
                              Save
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              type="button"
                              className="m-1"
                              size="sm"
                              color="danger"
                              onClick={() =>
                                handleDelete(TransType.trans_type_id)
                              }
                            >
                              Delete
                            </Button>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleEdit(TransType)}
                            >
                              Edit
                            </Button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  );
}
